import { render, staticRenderFns } from "./vector.vue?vue&type=template&id=03a60c85&scoped=true"
import script from "./vector.vue?vue&type=script&lang=ts"
export * from "./vector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a60c85",
  null
  
)

export default component.exports